module.exports = __webpack_public_path__ + "images/ds_smalldc3babfaf2bc351c53e0f1b025bb35b5.png";